import React, { useState } from "react";
import "../../styles/main.css";
import theme from "../../styles/theme";

import TabsBase from "../../components/reusable/Navigation/TabsBase";
import ContainerBase from "../../components/framepart/SubpageLayout/ContainerBase";
import ToolbarHeadSubpage from "../../components/framepart/SubpageLayout/ToolbarHeadSubpage";
import DropdownMulti from "../../components/reusable/Forms/DropdownMulti";
import DropdownList from "../../components/reusable/Forms/DropdownList";
import Button from "../../components/reusable/Forms/Button";
import TextFilter from "../../components/reusable/Forms/TextFilter";
import Switch from "../../components/reusable/Forms/Switch";
/* ============================================================
   OPTIONS GÉNÉRIQUES
============================================================ */
const demoOptions = [
  { value: "opt1", label: "Option 1" },
  { value: "opt2", label: "Option 2" },
  { value: "opt3", label: "Option 3" },
];

/* ============================================================
   FACTORISATION — Styles communs aux containers
============================================================ */
const baseLeftZoneStyle = {
  flex: 3,
  minWidth: 700,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  background: theme.colors.background.surface,
  border: `1px solid ${theme.colors.borders.default}`,
  overflowX: "auto",
  overflowY: "auto",
  flexShrink: 0,
};

const baseRightZoneStyle = {
  flex: 1,
  minWidth: 350,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  background: theme.colors.background.surface,
  border: `1px solid ${theme.colors.borders.default}`,
  overflowX: "auto",
  overflowY: "auto",
  boxSizing: "border-box",
  flexShrink: 0,
};

/* ============================================================
   PAGE
============================================================ */
const Subpage_105 = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [switchOn, setSwitchOn] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [selectedCategories, setSelectedCategories] = useState([]);

  /* ============================================================
     ZONE A1
  ============================================================ */
  const zoneA1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone A1 — Section 1",
        content: <div>Contenu générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE A2
  ============================================================ */
  const zoneA2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone A2 — Informations",
        content: <div>Texte générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE B1
  ============================================================ */
  const zoneB1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone B1 — Section principale",
        content: <div>Contenu générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE B2
  ============================================================ */
  const zoneB2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone B2 — Informations secondaires",
        content: <div>Texte générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE C1
  ============================================================ */
  const zoneC1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone C1 — Vue générale",
        content: <div>Aucun élément sélectionné.</div>,
      },
    ],
  };

  /* ============================================================
     ZONE C2
  ============================================================ */
  const zoneC2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone C2 — Paramètres",
        content: <div>Configuration non définie…</div>,
      },
    ],
  };


  /* ============================================================
     ZONE D1
  ============================================================ */
  const zoneD1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone D1 — Section 1",
        content: <div>Contenu générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE D2
  ============================================================ */
  const zoneD2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone D2 — Informations",
        content: <div>Texte générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE E1
  ============================================================ */
  const zoneE1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone E1 — Section principale",
        content: <div>Contenu générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE E2
  ============================================================ */
  const zoneE2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone E2 — Informations secondaires",
        content: <div>Texte générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE F1
  ============================================================ */
  const zoneF1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone F1 — Vue générale",
        content: <div>Aucun élément sélectionné.</div>,
      },
    ],
  };

  /* ============================================================
     ZONE F2
  ============================================================ */
  const zoneF2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone F2 — Paramètres",
        content: <div>Configuration non définie…</div>,
      },
    ],
  };


  /* ============================================================
     TABS
  ============================================================ */
  const TabA = (
    <div style={tabStyle}>
      <ContainerBase {...zoneA1} />
      <ContainerBase {...zoneA2} />
    </div>
  );

  const TabB = (
    <div style={tabStyle}>
      <ContainerBase {...zoneB1} />
      <ContainerBase {...zoneB2} />
    </div>
  );

  const TabC = (
    <div style={tabStyle}>
      <ContainerBase {...zoneC1} />
      <ContainerBase {...zoneC2} />
    </div>
  );

  const TabD = (
    <div style={tabStyle}>
      <ContainerBase {...zoneD1} />
      <ContainerBase {...zoneD2} />
    </div>
  );

  const TabE = (
    <div style={tabStyle}>
      <ContainerBase {...zoneE1} />
      <ContainerBase {...zoneE2} />
    </div>
  );

  const TabF = (
    <div style={tabStyle}>
      <ContainerBase {...zoneF1} />
      <ContainerBase {...zoneF2} />
    </div>
  );


  const tabs = [
    { label: "List", content: TabA },
    { label: "Types & Taxonomy", content: TabB },
    { label: "Builder", content: TabC },
    { label: "Mapping", content: TabD },
    { label: "Validation", content: TabE },
    { label: "Export", content: TabF },
  ];

  /* ============================================================
     RENDER
  ============================================================ */
  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        width: "100%",
        height: "100%",
        overflowX: "hidden",
        overflowY: "visible",
      }}
    >
      <ToolbarHeadSubpage
  style={{
    padding: 24,
    height: 50,
    minHeight: 50,
    overflow: "visible",
    background: "transparent",
  }}

  /* -----------------------------------------------------------
     ZONE GAUCHE — Boutons
  ----------------------------------------------------------- */
  left={[
    <Button
      variant="blue"
      onClick={() => alert("Template — action fictive")}
    >
      Nouvel élément
    </Button>,
  ]}

  /* -----------------------------------------------------------
     ZONE CENTRALE — Dropdown + Recherche
  ----------------------------------------------------------- */
  center={[
    <DropdownMulti
      label="Catégorie"
      options={demoOptions}
      selectedValues={selectedCategories}
      onChange={setSelectedCategories}
      width={300}
      height={32}
    />,

    <TextFilter
      label="Recherche"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder="Tapez un texte..."
      style={{ marginBottom: 0 }}
    />,
  ]}

  /* -----------------------------------------------------------
     ZONE DROITE — Switch
  ----------------------------------------------------------- */
  right={[
    <Switch
      label="Actifs"
      enabled={switchOn}
      onChange={setSwitchOn}
      showText={false}
      size="small"
    />,
  ]}
/>


      <TabsBase tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
};

/* ============================================================
   STYLE COMMUN TABS
============================================================ */
const tabStyle = {
  display: "flex",
  flexDirection: "row",
  gap: 10,
  padding: 10,
  overflowY: "clip",
  overflowX: "hidden",
  minWidth: "fit-content",
  boxSizing: "border-box",
};

export default Subpage_105;
